<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>统计与监控</el-breadcrumb-item>
      <el-breadcrumb-item>图形化年报表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.loginname" @keyup.enter.native="clicksearch" placeholder="请输入登录名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入姓名" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.cardnumber" @keyup.enter.native="clicksearch" placeholder="请输入保修卡号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.bomsn" placeholder="请选择" class="select" style="width: 200px;">
              <el-option label="请选择设备类型" value=""></el-option>
              <el-option
                v-for="item in bomSnList" :key="item.Value" :label="item.Label" :value="item.Value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.saletype" placeholder="请选择" class="select" style="width: 200px;">
              <el-option
                v-for="item in saleTypeList" :key="item.Value" :label="item.Label" :value="item.Value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.diopterstate" placeholder="请选择" class="select" style="width: 150px;">
              <el-option label="请选择屈光状态" value="0"></el-option>
              <el-option label="正视" value="6"></el-option>
              <el-option label="远视" value="2"></el-option>
              <el-option label="近视" value="1"></el-option>
              <el-option label="散光" value="7"></el-option>
              <el-option label="老花" value="3"></el-option>
              <el-option label="屈光参差" value="8"></el-option>
              <el-option label="远视性弱视" value="9"></el-option>
              <el-option label="散光性弱视" value="10"></el-option>
              <el-option label="近视性弱视" value="11"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="primary" @click="clickexcel" v-if="SubRule_ExcelAnnualReport">导出Excel</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table v-loading="loading" :data="dataList" border stripe >
          <el-table-column prop="Loginname" label="登录名称" min-width="4%"></el-table-column>
          <el-table-column prop="Name" label="姓名" min-width="4%"></el-table-column>
          <el-table-column prop="Jigouname" label="归属机构" min-width="7%"></el-table-column>
          <el-table-column prop="BomsnName" label="设备类型" min-width="4%"></el-table-column>
          <el-table-column prop="SaletypeName" label="销售类型" min-width="4%"></el-table-column>
          <el-table-column prop="Cardnumber" label="保修卡号" min-width="6%"></el-table-column>
          <el-table-column prop="Createtimef" label="注册日期" min-width="6%"></el-table-column>
          <el-table-column label="初始屈光度" align="center">
              <el-table-column prop="Righteyedegreef" label="OD" min-width="5%"></el-table-column>
              <el-table-column prop="Lefteyedegreef" label="OS" min-width="5%"></el-table-column>
          </el-table-column>
          <el-table-column label="初始裸眼视力" align="center">
              <el-table-column prop="Nakedrighteyedegreef" label="OD" min-width="4%"></el-table-column>
              <el-table-column prop="Nakedlefteyedegreef" label="OS" min-width="4%"></el-table-column>
              <el-table-column prop="Nakedbinoculusdegreef" label="OU" min-width="4%"></el-table-column>
          </el-table-column>
          <el-table-column prop="Createtimel" label="最新复查日期" min-width="6%"></el-table-column>
          <el-table-column label="最新复查屈光度" align="center">
              <el-table-column prop="Righteyedegreel" label="OD" min-width="5%"></el-table-column>
              <el-table-column prop="Lefteyedegreel" label="OS" min-width="5%"></el-table-column>
          </el-table-column>
          <el-table-column label="最新复查裸眼视力" align="center">
              <el-table-column prop="Nakedrighteyedegreel" label="OD" min-width="4%"></el-table-column>
              <el-table-column prop="Nakedlefteyedegreel" label="OS" min-width="4%"></el-table-column>
              <el-table-column prop="Nakedbinoculusdegreel" label="OU" min-width="4%"></el-table-column>
          </el-table-column>
          <el-table-column label="球镜度对比" align="center">
              <el-table-column prop="Righteyedegreedif" label="OD" min-width="3%"></el-table-column>
              <el-table-column prop="Lefteyedegreedif" label="OS" min-width="3%"></el-table-column>
          </el-table-column>
          <el-table-column label="裸眼视力对比" align="center">
              <el-table-column prop="Nakedrighteyedegreedif" label="OD" min-width="3%"></el-table-column>
              <el-table-column prop="Nakedlefteyedegreedif" label="OS" min-width="3%"></el-table-column>
              <el-table-column prop="Nakedbinoculusdegreedif" label="OU" min-width="3%"></el-table-column>
          </el-table-column>
          <el-table-column label="操作" min-width="4%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goViewDetails(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <el-tab-pane label="查看详情" name="second" disabled="disabled">
        <AnnualReportDetails ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></AnnualReportDetails>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import AnnualReportDetails from '@/componentsSubVue/AnnualReportDetails.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou,
    AnnualReportDetails
  },
  name: 'MyAnnualReport',
  data () {
    return {
      loading: false,
      activeName: 'first',
      bomSnList: [],
      saleTypeList: [],
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询客户
      keywords: {
        loginname: '',
        name: '',
        cardnumber: '',
        jigouid: '-1',
        jigouname: '',
        bomsn: '',
        saletype: '0',
        diopterstate: '0'
      },
      SubRule_ExcelAnnualReport: false
    }
  },
  mounted () {
    this.apiAnnualReportnum()
    this.apiAnnualReportlist()

    var that = this
    Vue.prototype.FunListBomsn(function (response) {
      if (response.data.Code === 200) {
        that.bomSnList = response.data.List
        that.saleTypeList = response.data.ListSaleType
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ExcelAnnualReport', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ExcelAnnualReport = true
      }
    })
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clickreturn () {
      this.activeName = 'first'
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiAnnualReportlist()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiAnnualReportnum()
      this.apiAnnualReportlist()
    },
    clickexcel () {
      this.apiExcelAnnualReport()
    },
    // 查看详情
    goViewDetails (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData({ name: '', params: { userid: row.Id } })
    },
    apiAnnualReportlist: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        loginname: that.keywords.loginname,
        name: that.keywords.name,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid,
        bomsn: that.keywords.bomsn,
        saletype: that.keywords.saletype,
        diopterstate: that.keywords.diopterstate
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AnnualReportlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiAnnualReportnum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        loginname: that.keywords.loginname,
        name: that.keywords.name,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid,
        bomsn: that.keywords.bomsn,
        saletype: that.keywords.saletype,
        diopterstate: that.keywords.diopterstate
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AnnualReportnum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelAnnualReport: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        loginname: that.keywords.loginname,
        name: that.keywords.name,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid,
        bomsn: that.keywords.bomsn,
        saletype: that.keywords.saletype,
        diopterstate: that.keywords.diopterstate
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelAnnualReport, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
